<template>
  <q-card-actions
    align="right"
    class="q-gutter-sm"
  >
    <slot name="left" />
    <q-space />
    <slot />
    <q-btn
      v-close-popup
      label="Annuler"
      color="negative"
      @click="$emit('cancel')"
    />
    <q-btn
      type="submit"
      label="Confirmer"
      color="primary"
      :disable="disable"
      @click="$emit('submit')"
    />
  </q-card-actions>
</template>

<script>
export default {
  name: 'DialogComponentFooter',
  props: {
    disable: Boolean
  }
}
</script>

<style scoped>

</style>
